import React, { useEffect } from 'react';
import Sidenavigation1 from '../../layouts/Sidenavigation1';
import Topnavigation from '../../layouts/Topnavigation';

import { HomePContextProvider } from '../../MyContexts/HomeP_Context';
import { TheMasterContextProvider } from '../../MyContexts/Master_Context';
import HomePSet from './HomePSet';


const HomePage = (props) => {

    useEffect(() => {

    }, [])

    return (
        <div className="ms-body ms-aside-left-open ms-primary-theme ms-has-quickbar">
            <TheMasterContextProvider>
                    <Sidenavigation1 />
                    <main className="body-content">
                        <Topnavigation />
                        <HomePContextProvider>
                            <HomePSet />
                        </HomePContextProvider>
                    </main>
                    {/* <Quickbar /> */}
               
            </TheMasterContextProvider>

        </div>
    );
}

export default HomePage;